import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  // Radio Groups
  radioGroupContainer: {
    minHeight: '80px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },

  //credit card styles (no top/bottom margin – Stack gap controls spacing)
  textField: {
    width: '100%',
    [theme.breakpoints.down('md')]: {
      paddingRight: 0,
    },
  },
  /** Keeps country/postal inputs the same height in the billing row. */
  billingRowField: {
    width: '100%',
    minWidth: 0,
    '& .MuiFilledInput-root': {
      height: 56,
      boxSizing: 'border-box',
    },
    '& .MuiSelect-select': {
      display: 'flex',
      alignItems: 'center',
      minHeight: 'unset',
    },
  },
  billingRowGrid: {
    display: 'grid',
    gap: theme.spacing(2),
    width: '100%',
    gridTemplateColumns: '2fr 1fr',
    '& > *': { minWidth: 0 },
  },
  links: {
    padding: theme.spacing(0, 1, 0, 1),
  },
  // Card input: height 56px, content in middle via equal top/bottom padding (no flex so CardElement iframe renders).
  // MUI FilledInput backgrounds: light default 0.06, hover 0.09, focus 0.06; dark default 0.09, hover 0.13, focus 0.09.
  cardInputContainer: {
    width: '100%',
    height: 56,
    boxSizing: 'border-box',
    padding: theme.spacing(1, 1.5),
    zIndex: 0,
    borderRadius: '4px',
    alignContent: 'center',
    ...(theme.palette.mode === 'light'
      ? {
          backgroundColor: 'rgba(0, 0, 0, 0.06)',
          transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut,
          }),
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.09)',
          },
          '&:focus-within': {
            backgroundColor: 'rgba(0, 0, 0, 0.06)',
          },
        }
      : {
          backgroundColor: 'rgba(255, 255, 255, 0.09)',
          transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut,
          }),
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.13)',
          },
          '&:focus-within': {
            backgroundColor: 'rgba(255, 255, 255, 0.09)',
          },
        }),
  },
  menu: {
    padding: 0,
    maxHeight: '300px',
  },
  bitPayContainer: {
    [theme.breakpoints.down('xl')]: {
      marginTop: theme.spacing(1),
    },
  },
}));

export default useStyles;
